import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/PaymentPackageStatus.graphql';
import { Query, QuerypaymentPackageStatusArgs } from '../../__generated__/globalTypes';

export const usePaymentPackageStatusQuery = (options?: QueryHookOptions<Query, QuerypaymentPackageStatusArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerypaymentPackageStatusArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const usePaymentPackageStatusLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerypaymentPackageStatusArgs>
): QueryResult<Query, QuerypaymentPackageStatusArgs> & {
  getPaymentPackageStatus: LazyQueryExecFunction<Query, QuerypaymentPackageStatusArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getPaymentPackageStatus, result] = useLazyQuery<Query, QuerypaymentPackageStatusArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getPaymentPackageStatus, ...result };
};

export const usePaymentPackageStatusPromiseQuery = () => {
  const client = useApolloClient();

  const getPaymentPackageStatus = useCallback(
    (options?: Omit<QueryOptions<QuerypaymentPackageStatusArgs, Query>, 'query'>) =>
      client.query<Query, QuerypaymentPackageStatusArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getPaymentPackageStatus };
};
// Suspense Query Hooks
export const usePaymentPackageStatusSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerypaymentPackageStatusArgs>
) => {
  const result = useSuspenseQuery<Query, QuerypaymentPackageStatusArgs>(QUERY, {
    ...options
  });

  return result;
};
